import { render, staticRenderFns } from "./RegisterApp.vue?vue&type=template&id=2ec59372&"
import script from "./RegisterApp.vue?vue&type=script&lang=js&"
export * from "./RegisterApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports